<template>
  <form class="server" action="" @submit.prevent.stop="completeSetup" autocomplete="off">
    <div id="setup" class="container pt-5">
      <div class="row">
        <div class="col-md-12 d-flex justify-content-between align-items-baseline">
          <div class="steptracker mb-2">{{ $t('message.step') }} {{activeStep+1}}/4</div>
          <div class="">
            <button @click.prevent="skipSetup" class="small p-0 btn btn-link">{{ $t('message.skip_setup') }}</button>
          </div>
        </div>
      </div>
      <div v-show="activeStep === 0">
        <div class="row intro">
          <div class="col-md-12">
            <h2>{{ $t('message.introduction') }}</h2>
            <p>
              {{ $t('message.please_complete_the_following_steps_to_begin') }}
            </p>
          </div>
        </div>
      </div>
      <div class="row" v-show="activeStep === 1">
        <div class="col-md-12">
          <h2>{{ $t('message.server_setup') }}</h2>
          <div class="form-row">
            <div class="col-md-12">
              <ul class=" m-0 pl-3 errors mb-3">
                <li v-for="m in messages.server">{{m}}</li>
              </ul>
              <label for="">{{ $t('message.server_url') }}</label>
              <div class="form-row">
                <div class="col-auto">
                  <select v-model="server.protocol" name="" id="" class="form-control styled-input">
                    <option value="https">https://</option>
                    <option value="http">http://</option>
                  </select>
                </div>
                <div class="col"><input v-model="server.url" class="styled-input form-control" type="text">
                </div>
              </div>

            </div>
            <div class="col-md-12">
              <label for="">{{ $t('message.port') }}</label>
              <input v-model="server.port" class="styled-input form-control" value="80" type="text">
              <div class="actions mt-3">
                <button v-show="connectionLoader === false" @click.prevent="serverValidation" class="btn btn-primary">
                  {{ $t('message.test_connection') }}
                </button>
                <button disabled v-show="connectionLoader === true" @click.prevent="" class="btn btn-primary">
                  {{ $t('message.testing') }} <i class="fas fa-circle-notch fa-spin"></i></button>
                <span class="ml-3 text-success" v-if="connectionOk">
                  {{ $t('message.connection_ok') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-show="activeStep === 2">
        <div class="col-md-12">
          <h2>{{ $t('message.main_user_account') }}</h2>
          <div class="form-row">
            <div class="col-md-12">
              <ul class=" m-0 pl-3 errors mb-3">
                <li v-for="m in messages.user">{{m}}</li>
              </ul>
              <label for="">
                {{ $t('message.first_name') }}
              </label>
              <input autocomplete="new-account-fname" v-model="user.firstname" type="text"
                     class="form-control styled-input">
              <label for="">
                {{ $t('message.last_name') }}
              </label>
              <input autocomplete="new-account-lname" v-model="user.lastname" type="text"
                     class="form-control styled-input">
              <label for="">
                {{ $t('message.email') }}
              </label>
              <input autocomplete="new-account-mail" v-model="user.email" type="text" class="form-control styled-input">
              <label for="">
                {{ $t('message.password') }}
              </label>
              <input autocomplete="new-account-pw" v-model="user.password" name="create-password" id="pw"
                     type="password"
                     class="form-control styled-input">
              <label for="">
                {{ $t('message.confirm_password') }}
              </label>
              <input autocomplete="new-account-pwc" v-model="user.confirm_password" name="create-password"
                     id="pw-confirm" type="password"
                     class="form-control styled-input">
              <!--                            <button @click.prevent="createUser" class="btn btn-primary" type="submit">Test submit user</button>-->

            </div>
          </div>
        </div>
        <!--    </form>-->
      </div>
      <div class="row" v-show="activeStep === 3">
        <!--    <form class="row company" action="">-->
        <div class="col-md-12">
          <h2>{{ $t('message.company_setup') }}</h2>
          <div class="form-row">
            <form class="col-md-12 companyform">
              <ul class=" m-0 pl-3 errors mb-3">
                <li v-for="m in messages.company">{{m}}</li>
              </ul>
              <label for="">{{ $t('message.company_name') }}</label>
              <input name="Title" v-model="company.Title" type="text" class="form-control styled-input">
              <label for="">{{ $t('message.information') }}</label>
              <input name="Information" v-model="company.Information" type="text" class="form-control styled-input">
              <label for="">{{ $t('message.logo') }}</label>
              <file-upload :image-url="''"
                           class="styled-input"
                           :name="'files'">
              </file-upload>
              <!--              <input name="Logo" id="Logo" type="file" class="form-control styled-input">-->
              <!--              <button @click.prevent="createCompany" class="btn btn-primary" type="submit">Test submit company</button>-->
            </form>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-md-12 stepnav text-right mt-3">
          <button type="button" v-if="activeStep > 0" @click.prevent.stop="goToStep(activeStep-1)" class="btn btn-link">
            {{ $t('message.back') }}
          </button>
          <button type="button" v-if="activeStep < 3"
                  @click.prevent.stop="goToStep(activeStep+1,true)"
                  class="btn btn-primary">
            {{ $t('message.next') }}
          </button>
          <button type="submit" v-if="activeStep === 3 && confirmLoader === false" class="btn btn-primary">
            {{ $t('message.complete_setup') }}
          </button>

          <button v-if="activeStep === 3 && confirmLoader === true" @click.prevent="" disabled type="button"
                  class="btn btn-primary">
            {{ $t('message.complete_setup') }} <i class="fas fa-circle-notch fa-spin"></i></button>


        </div>
      </div>
      <!--    <button @click.prevent="test">test</button>-->
    </div>

  </form>
</template>

<script>

  import axios from 'axios'
  import store from "../../store/store";
  import FileUpload from "../FileUpload";
  import router from "../../router";

  export default {
    components: {
      FileUpload
    },
    data() {
      return {
        mainUserId: null,
        connectionOk: false,
        server: {
          protocol: 'http',
          url: 'localhost',
          port: '1337'
        },
        confirmLoader: false,
        connectionLoader: false,
        validServer: true,
        invalidSteps: [],
        messages: {
          server: [],
          user: [],
          company: [],
        },
        activeStep: 0,
        user: {
          role: 3, //hr role id
          firstname: '',
          lastname: '',
          email: '',
          password: '',
          confirm_password: '',
        },
        company: {
          Title: '',
          Information: '',
        }
      }
    },
    methods: {
      createUser(e) {
        this.user.fullname = this.user.firstname + ' ' + this.user.lastname;
        // this.user.username = this.safeName(this.user.firstname) + this.safeName(this.user.lastname),
        this.user.username = this.user.email;
        this.axios.post(this.server.protocol + '://' + this.server.url + ':' + this.server.port + '/mainusers/createuser', this.user).then(res => {
          //  console.log('created user in install', res);
          this.mainUserId = res.data.id;
          // this.axios.post(this.server.protocol + '://' + this.server.url + ':' + this.server.port + '/users', this.user).then(res => {
          this.createCompany();
        })
      },
      createCompany(e) {
        //todo: new endpoint will be: /mainusers/createcompany POST

        const formElement = document.querySelector('.companyform');
        const formData = new FormData();
        const formElements = formElement.elements;
        const data = {};

        for (let i = 0; i < formElements.length; i++) {
          const currentElement = formElements[i];
          if (!['submit', 'file'].includes(currentElement.type)) {
            data[currentElement.name] = currentElement.value;
          } else if (currentElement.type === 'file') {
            if (currentElement.files.length === 1) {
              const file = currentElement.files[0];
              formData.append(`files.${currentElement.name}`, file, file.name);
            } else {
              for (let i = 0; i < currentElement.files.length; i++) {
                const file = currentElement.files[i];

                formData.append(`files.${currentElement.name}`, file, file.name);
              }
            }
          }
        }

        formData.append('data', JSON.stringify(data));
        for (let pair of formData.entries()) {
          //  console.log('filedata', pair);
        }
        this.axios.post(this.server.protocol + '://' + this.server.url + ':' + this.server.port + '/mainusers/createcompany', formData).then(res => {
          // this.axios.post(this.server.protocol + '://' + this.server.url + ':' + this.server.port + '/companies', formData).then(res => {
          //  console.log('post company response', res);
          this.axios.post(this.server.protocol + '://' + this.server.url + ':' + this.server.port + '/mainusers',
            {user: this.mainUserId}
          )
            .then(res => {
              this.setServer(this.server.protocol + '://' + this.server.url, this.server.port)
              //  console.log('creating main user', res)
            })
        })
      },
      async validateStep(step) {
        // let valid = {result: true};
        if (step < 3) {
          return {result: true}
        } else {
          if (step === 2) {
            const valid = this.serverValidation();
            // console.log('servervalidation return',valid)
            return await valid;
          }
          if (step === 3) {
            const valid = this.userValidation();
            // console.log('uservalidation return',valid)
            return valid
          }
          if (step === 4) {
            const valid = this.companyValidation();
            // console.log('companyvalidation return',valid)
            return valid
          }
        }
        // console.log('validation', valid)

        // return valid.result;
      },

      goToStep(step, validate = false) {
        // console.log('tostep',step)
        let valid = true;
        if (validate) {
          valid = this.validateStep(step).then(v => {
            // console.log('validating step', [step, v])
            valid = v;
            if (valid.result) {
              if (step >= 0 && step <= 3) {
                this.activeStep = step;
              }
            }
          })
          // console.log('validated step', [step, valid])
        } else {
          if (step >= 0 && step <= 3) {
            this.activeStep = step;
          }
        }

      },
      userValidation() {
        let valid = {result: true, messages: [], step: 2};
        Object.keys(this.user).forEach((key, ind) => {
          if (this.user[key].length < 1) {
            valid.result = false;
            if (key === 'lastname') {
              key = 'last_name'
            }
            if (key === 'firstname') {
              key = 'first_name'
            }
            let keyname = this.$t('message.' + key);


            //
            // let keyname = key.replace(/_/g, ' ');
            // keyname = this.capitalize(keyname)
            valid.messages.push(keyname + ' ' + this.$t('message.cannot_be_empty') + '.')
          }
        });

        if (!this.validateMail(this.user.email)) {
          valid.result = false;
          valid.messages.push(this.$t('message.email_is_not_valid') + '.')
        }

        if (this.user.password.length < 6) {
          valid.result = false;
          valid.messages.push(this.$t('message.password_needs_to_be_at_least_characters_long', {length: '6'}) + '.')
        }
        if (this.user.password !== this.user.confirm_password) {
          valid.result = false;
          valid.messages.push(this.$t('message.passwords_do_not_match') + '.')
        }

        this.messages.user = [];
        this.messages.user = valid.messages;
        return valid;
      },
      companyValidation() {

        let valid = {result: true, messages: [], step: 3};
        Object.keys(this.company).forEach((key, ind) => {
          if (this.company[key].length < 1) {
            valid.result = false;
            valid.messages.push(key + ' cannot be empty.')
          }
        });

        this.messages.company = [];
        this.messages.company = valid.messages;
        return valid;
      },

      async serverValidation() {
        this.connectionLoader = true;
        this.messages.server = [];
        this.connectionOk = false;
        let valid = {result: true, messages: [], step: 1};
        Object.keys(this.server).forEach((key, ind) => {
          if (this.server[key].length < 1) {
            this.connectionLoader = false;
            valid.result = false;
            valid.messages.push(key + ' cannot be empty.')
          }
        });
        await this.axios.get(this.server.protocol + '://' + this.server.url + ':' + this.server.port + '/mainusers/count')
          .then(r => {
            if (r.status !== 200) {
              if (typeof r === 'undefined') {
                valid.messages.push('Connection not valid')
              } else {
                valid.messages.push('Connection error: ' + r.status + ': ' + r.statusText)
              }

              valid.result = false;
            } else {
              if (r.data > 0) {
                // if (r.data.length > 0) {
                //todo modify query to fetch only users flagged as main user, if result, give following error
                valid.result = false;
                valid.messages.push(this.$t('message.target_server_full'))
              } else {
                this.connectionOk = true;
              }
            }
            // console.log('returning server validation',valid)
            this.messages.server = [];
            this.messages.server = valid.messages;
            this.connectionLoader = false;
            return valid;
          })
          .catch(r => {
            valid.result = false;
            valid.messages.push(r);
            this.messages.server = [];
            this.messages.server = valid.messages;
            this.connectionLoader = false;
            return valid;
          });
        return valid
      },
      isValidated() {
        let valid = true;
        let userValid = this.userValidation();
        let companyValid = this.companyValidation();
        if (!userValid.result || !companyValid.result) {
          valid = false
        }
        if (!userValid.result) {
          this.goToStep(2)
        } else if (!companyValid.result) {
          this.goToStep(3)
        }

        return valid
      },
      completeSetup() {
        this.confirmLoader = true;
        let validated = this.isValidated();
        // console.log('validating complete setup', validated)
        if (validated) {
          this.serverValidation().then(r => {
            // console.log('validating server at end', r)
            if (r) {
              this.createUser();
            } else {
              this.confirmLoader = false;
              this.goToStep(1)
            }
          });
        } else {
          this.confirmLoader = false;
        }
      },

      skipSetup() {
        this.axios.defaults.baseURL = 'http://localhost:1337';
        this.globalAxios.defaults.baseURL = 'http://localhost:1337';
        store.commit("setUrl", 'http://localhost');
        store.commit("setPort", '1337');
        store.commit('setSetupStatus', true);

        const token = localStorage.getItem('user-token');
        if (token) {
          this.axios.defaults.headers = {
            Authorization:
              'Bearer ' + token,
          };

          this.axios.get('/teams/myteam').then(r => {
            store.commit('setManagedTeams', r.data);
          });

          this.axios.get('/users/me').then(u => {
            const user = u.data;
            store.commit("setUser", user);
            this.axios.get('/companies?_sort=created_at:DESC&_limit=1').then(r => {
              const company = r.data[0];
              store.commit("setCompany", company);
            })
          });
        }

        this.$router.push('/')
      },

      setServer(url, port) {
        // console.log('posting', [url, port]);
        axios.post('/static/setup.php', {
          url: url,
          port: port
        }).then(res => {
          // console.log('php response', res);
          let success = true;
          //todo check response if json file was written successfully
          if (success) {
            this.confirmLoader = false;
            this.axios.defaults.baseURL = url + ':' + port;
            this.globalAxios.defaults.baseURL = url + ':' + port;
            store.commit("setUrl", url);
            store.commit("setPort", port);
            store.commit('setSetupStatus', true);
            store.dispatch('signin', {email: this.user.email, password: this.user.password, vm: this});
          } else {
            //   console.log(res)
            this.confirmLoader = false;
          }
        })
      }
    },
    created() {

    },
    mounted() {
    }
  }
</script>

<style>
  .errors {
    margin-bottom: 15px;
    color: red;
  }

  .btn.small {
    font-size: 80%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Account/Setup.vue